import { CabinetContainer, DashboardCards, TransactionHistory, Transfer } from 'components';
import { ChartIcon, TeamIcon, WalletIcon, CoinIcon, TetherIcon } from 'components/ui/icons';
import { useFinanceQuery } from 'redux/api/common';
import { withTranslation } from 'react-i18next';

const Finance = ({ t }) => {
  const { data } = useFinanceQuery();

  const cards = [
    {
      title: {
        text: t('earned-total'),
        icon: <ChartIcon />,
      },
      fields: [
        {
          key: `${t('earned-total')} CAN`,
          value: {
            isBig: false,
            text: `${data?.profit.amount} CAN`,
            icons: [<CoinIcon />]
          }
        },
        {
          key: `${t('earned-total')} $`,
          value: {
            isBig: false,
            text: `${data?.profit.usd} $`,
            icons: [<TetherIcon />]
          }
        },
      ],
    },
    {
      title: {
        text: `${t('affilate')} ${t('program').toLowerCase()}`,
        icon: <WalletIcon />,
      },
      fields: [
        {
          key: `${t('affilate')} CAN`,
          value: {
            isBig: false,
            text: `${data?.profit_affiliate.amount} CAN`,
            icons: [<CoinIcon />]
          }
        },
        {
          key: `${t('affilate')} $`,
          value: {
            isBig: true,
            text: `${data?.profit_affiliate.usd} $`,
            icons: [<TetherIcon />]
          }
        },
      ],
    },
    {
      title: {
        text: `${t('packages')} ${t('income').toLowerCase()}`,
        icon: <TeamIcon />,
      },
      fields: [
        {
          key: `${t('income')} CAN`,
          value: {
            isBig: false,
            text: `${data?.profit_package.amount} CAN`,
            icons: [<CoinIcon />]
          }
        },
        {
          key: `${t('income')} $`,
          value: {
            isBig: true,
            text: `${data?.profit_package.usd} $`,
            icons: [<TetherIcon />]
          }
        },
      ],
    },
  ];

  return (
    <CabinetContainer>
      <div>
        <h1>{t('finance')}</h1>
        {window.innerWidth > 1200 &&
          <DashboardCards cards={cards} />
        }
      </div>
      <div>
        <Transfer />
      </div>
      <div>
        <h2>{t('transition-history')}</h2>
        <TransactionHistory />
      </div>
    </CabinetContainer>
  );
}

export default withTranslation('finance')(Finance);
